export default [
    {
        id: 1,
        name_ca: 'Desconeguda',
        name_es: 'Desconocida',
        name_en: 'Unknown'
    }, {
        id: 2,
        name_ca: 'Formigó armat',
        name_es: 'Hormigón armado',
        name_en: 'Reinforced Concrete'
    }, {
        id: 3,
        name_ca: 'Murs de càrrega',
        name_es: 'Muros de carga',
        name_en: 'Bearing walls'
    }, {
        id: 4,
        name_ca: 'Metàl·lica',
        name_es: 'Metálica',
        name_en: 'Metal'
    }
]





// WEBPACK FOOTER //
// ./src/options/structures.js